import { asteroid } from "data/meteor-server";
import { sanitizePhoneNumber } from "./utils";

export const onSendSMSVerification = (phoneNumber: string): Promise<string> =>
  new Promise((resolve, reject) => {
    const number = sanitizePhoneNumber(phoneNumber);

    if (number.length !== 10) {
      reject(new Error("Invalid phone number. Example: 555-111-3333"));
      return;
    }

    asteroid
      .call("User.hasAccount", `+1${number}@havenconnect.com`)
      .then((hasAccount: boolean) => {
        if (!hasAccount) {
          reject(new Error("No account for that cell phone"));
          return;
        }

        asteroid
          .call("accounts-sms.sendVerificationCode", `+1${number}`)
          .then(resolve)
          .catch((err: { error: string }) => {
            reject(err.error);
          });
      })
      .catch((err: Error) => {
        reject(err.message);
      });
  });

export const onSendEmailVerification =
  (email: string, options: { redirectURL: string }): Promise<unknown> => asteroid.call("requestEmailVerificationCode", {
    email,
    redirectUrl: options.redirectURL,
  });

export const onLoginEmail = (email: string, password: string): Promise<string> =>
  new Promise((resolve, reject) => {
    asteroid
      .loginWithPassword({ email, password })
      .then((userId: string) => {
        resolve(userId);
      })
      .catch((err: { error: number; reason: string }) => {
        reject(err.reason);
      });
  });

export const onLoginSMS = (phoneNumber: string, code: string): Promise<string> =>
  new Promise((resolve, reject) => {
    if (code === "") {
      reject(new Error("Please enter a login code."));
      return;
    }

    const number = sanitizePhoneNumber(phoneNumber);

    asteroid
      .login({ sms: true, phone: `+1${number}`, code })
      .then((userId: string) => {
        resolve(userId);
      })
      .catch((err: { error: string }) => {
        reject(err.error);
      });
  });
